var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{on:{"click":_vm.onEmojiClick}},[_vm._v(_vm._s(_vm.emoji.value))])}
var staticRenderFns = []

export { render, staticRenderFns }